import { gsap } from 'gsap';
import BBIntersectionObserver from '../../javascripts/intersection-observer';

const getElem = (parent, selector) => {
  return parent.querySelector(`[data-animation-element='${selector}']`);
};

export default function TeaserHighlightAnimation() {
  const selectorConfig = {
    stageArticle: {
      container: 'teaser-highlight',
      elements: {
        content: 'teaser-highlight__content',
        image: 'teaser-highlight__image'
      }
    }
  };

  // add BBIntersectionObserver
  const observer = new BBIntersectionObserver();

  Object.keys(selectorConfig).forEach((key) => {
    const selectors = selectorConfig[key];
    const { content, image } = selectors.elements;
    const containerElements = document.querySelectorAll(`[data-animation-container='${selectors.container}']`);

    // tracking code
    const trackClicks = (element, trackingData) => {
      element.addEventListener('click', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(trackingData);
      });
    };

    const linkElements = document.querySelectorAll('.teaser-highlight');
    linkElements.forEach((link) => {
      trackClicks(link, {
        event: 'highlight_teaser',
        targetUrl: link.href
      });
    });

    containerElements.forEach((containerElem) => {
      const target = containerElem;

      let tileElements = getElem(target, content);
      let tileChildren = [...tileElements.childNodes];

      // add navigation animation element
      if (target.classList.contains('teaser-highlight--is-stage')) {
        const navigationLeft = document.querySelector(`[data-animation-element='navigation__left--article']`);
        tileElements = [navigationLeft].concat(tileElements);
        tileChildren = [...navigationLeft.childNodes].concat(tileChildren);
      }

      // TODO sync inital style with teaser-highlight.scss & navigation.scss
      const initalAnimation = gsap
        .timeline({ paused: true })
        .to(getElem(target, image), { x: 10, opacity: 0.5 })
        .to(tileElements, { x: -10, opacity: 0 })
        .to(tileChildren, { opacity: 0 })
        .addLabel('hidden')
        .to(getElem(target, image), { opacity: 1, ease: 'power1.out', duration: 0.3 })
        .to(tileElements, { x: 0, opacity: 1, ease: 'power1.out', duration: 0.3 }, '<')
        .to(getElem(target, image), { x: 0, ease: 'power1.out', duration: 0.3 })
        .to(tileChildren, { opacity: 1, ease: 'power1.out', duration: 0.3 }, '<');

      target.timeline = initalAnimation;
      target.timeline.seek('hidden').pause();
      observer.observe(target);
    });
  });
}
